import { useNavigate } from "react-router-dom";
import { IRequest } from "../../../types/eventTypes";
import TitleAndLink from "../../reusable-components/title-and-link/TitleAndLink";
import PrePaidSlider from "./pre-paid-slider/PrePaidSlider";
import { ROUTE_PATHS } from "../../../routes";

interface PrePaidRequestsProps {
	eventRequests: IRequest[];
}
const PrePaidRequests = ({ eventRequests }: PrePaidRequestsProps) => {
	const navigate = useNavigate();
	return (
		<>
			<TitleAndLink
				title="Pre-Paid Requests"
				btnText={eventRequests?.length > 1 ? "View all" : ""}
				actionBtn={() => {
					navigate(ROUTE_PATHS.PRE_PAID_REQUESTS);
				}}
			/>
			<PrePaidSlider eventRequests={eventRequests} />
		</>
	);
};

export default PrePaidRequests;
